import * as z from "zod/v4";

export const fulfillFulfillmentGroupWithFreightBooking = {
  name: "fulfillFulfillmentGroupWithFreightBooking" as const,
  input: z.object({
    fulfillmentGroupId: z.string(),
    bolUrl: z.string(),
    scac: z.string(),
    carrierName: z.string(),
    quoteId: z.string(),
    shipmentTransactionId: z.string(),
    cost: z.number(),
    bolNumber: z.string(),
    trackingLink: z.string().nullish(),
  }),
  output: z.object({}),
};
